// Maps EPDServices.Domain.Enums.CommentType names to the UI text shown on the Comment Log page.
export const COMMENT_TYPE_LABELS: Record<string, string> = {
  DepublishedNotPaid: 'Depublished (not paid invoices)',
  DepublishedNonCompliant: 'Depublished (non-compliant)',
  SubmittedForPublicationEditorial: 'Changes description',
  PublicationDeclined: 'Publication declined',
};

// These comment types are shown in red per the Comment Log design.
export const HIGHLIGHTED_COMMENT_TYPES = new Set<string>([
  'DepublishedNotPaid',
  'DepublishedNonCompliant',
  'PublicationDeclined',
]);
